export default "__VITE_ASSET__Dibnz0h5__"